import { render, staticRenderFns } from "./PromotionRowColumn2.vue?vue&type=template&id=bf83010e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./PromotionRowColumn2.vue?vue&type=script&lang=ts"
export * from "./PromotionRowColumn2.vue?vue&type=script&lang=ts"
import style0 from "./PromotionRowColumn2.vue?vue&type=style&index=0&id=bf83010e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf83010e",
  null
  
)

export default component.exports